import { useContext } from "react";
import AuthContext from "../contexts/AuthProvider";
// to use current user 
const UseAuth = () => {
    return useContext(AuthContext);
}
// export component
export default UseAuth;